import { HIT_AREA_SIZE } from '@/components/app/editor/selection-chrome/selection-chrome-constants'

/** Hit target per handle — larger than the visible square, matching the old chrome's hit area. */
export const HANDLE_HIT_PX = HIT_AREA_SIZE
